import 'swiper/css/bundle';
import Swiper, { Navigation } from 'swiper';
Swiper.use([Navigation]);

import './timeline-carousel.scss';

const timelineCarousel = () => {

  const timelineSwiperSelector = document.querySelector('.timelineSwiper');
  const mobileTimelineSwiperSelector = document.querySelector('.mobile-proggres-swiper');

  if (timelineSwiperSelector) {

    let swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      allowTouchMove: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
        }
      },
      on: {
        init: function () {
          $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
          $(".swiper-pagination-custom .swiper-pagination-switch").eq(0).addClass("active");
          if (timelineSwiperSelector) {
            updateProgressBarWidth();
          }
        },
        slideChangeTransitionStart: function () {
          $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
          $(".swiper-pagination-custom .swiper-pagination-switch").eq(timelineSwiper.realIndex).addClass("active");
          updateProgressBarWidth();
          if (timelineSwiperSelector) {

            updateProgressBarWidth();
          }
        },
        slideChange: function() {
          $('.mobile-proggres-swiper .swiper-slide').removeClass('active');

            var activeIndex = timelineSwiper.activeIndex;

          $('.mobile-proggres-swiper .swiper-slide').eq(activeIndex).addClass('active');

          console.log("activeIndex",activeIndex)
        }
      }
    };
    let timelineSwiper = new Swiper(timelineSwiperSelector, swiperOptions);
    
    
    if (mobileTimelineSwiperSelector) {
      let mobileswiperOptions = {
        slidesPerView: "auto",
        autoHeight: true,
        centeredSlides: true,
        allowTouchMove: true,
       
        breakpoints: {
          1024: {
            spaceBetween: 0,
          }
        },
        on: {
          init: function () {
            $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
            $(".swiper-pagination-custom .swiper-pagination-switch").eq(0).addClass("active");
            if (timelineSwiperSelector) {
              updateProgressBarWidth();
            }
          },
          
        }
      };
      
      let mobileTimelineSwiper = new Swiper(mobileTimelineSwiperSelector, mobileswiperOptions);

      timelineSwiper.on('slideChange', function () {
        mobileTimelineSwiper.slideTo(timelineSwiper.realIndex);
      });

      mobileTimelineSwiper.on('slideChange', function () {
        timelineSwiper.slideTo(mobileTimelineSwiper.realIndex);
      });


      const slideCount = $('.mobile-proggres-swiper .swiper-slide').length;

      let mobileWrapperWidth;


      mobileWrapperWidth = slideCount * 120 + 'px';
      $('.mobile-proggres-swiper .swiper-wrapper').css('--mobileWrapperWidth', mobileWrapperWidth );




      // mobileTimelineSwiper.on('slideChange', function () {
      //   timelineSwiper.slideTo(mobileTimelineSwiper.realIndex);
      // });

      $(document).ready(function() {
        $('.mobile-proggres-swiper .swiper-slide').click(function() {
            $('.mobile-proggres-swiper .swiper-slide').removeClass('active');
            $(this).addClass('active');
            
            var index = $(this).index();
            console.log("index",index);
            mobileTimelineSwiper.slideTo(index);
            timelineSwiper.slideTo(index);

        });
    });
    }
    
    
    
    function updateProgressBarWidth() {
      const activeIndex = $('.swiper-pagination-switch.active').index();
      const switchCount = $('.swiper-pagination-switch').length;

      let progressWidth;

      progressWidth = (activeIndex / (switchCount - 1)) * 100 + '%';

      if (switchCount > 0 && activeIndex >= 0) {
        progressWidth = (activeIndex / (switchCount - 1)) * 100 + '%';
      }

      $('.swiper-pagination-progressbar').css('--progress-width', progressWidth);
      $('.draggable-handle').css('--progress-width', progressWidth);
    }

    const handle = document.querySelector('.draggable-handle.desktop-draggable');
    const progressBar = document.querySelector('.swiper-pagination-progressbar.desktop-pagination');

    function handleDrag(progressBar) {
      let isDragging = false;
      let startX;
      let startLeft;
    
      if (handle) {
        const handleStyle = handle.style;
        const handleTransition = handleStyle.transition;
    
        handle.addEventListener('mousedown', startDragging);
        handle.addEventListener('touchstart', startDragging);
    
        function startDragging(event) {
          console.log("start");
          event.preventDefault();
          isDragging = true;
          startX = event.clientX || event.touches[0].clientX;
          startLeft = parseFloat(getComputedStyle(handle).left);
          handleStyle.transition = 'none';
    
          document.addEventListener('mousemove', drag);
          document.addEventListener('touchmove', drag);
          document.addEventListener('mouseup', stopDragging);
          document.addEventListener('touchend', stopDragging);
        }
    
        function drag(event) {
          if (isDragging) {
            const clientX = event.clientX || event.touches[0].clientX;
            const deltaX = clientX - startX;
            const progressBarWidth = progressBar.offsetWidth;
            const handleWidth = handle.offsetWidth;
            let newLeft = startLeft + deltaX;
            newLeft = Math.max(0, Math.min(newLeft, progressBarWidth - handleWidth));
            handleStyle.left = newLeft + 'px';
          }
        }
    
        function stopDragging() {
          if (isDragging) {
            isDragging = false;
            handleStyle.transition = handleTransition;
            const progressBarWidth = progressBar.offsetWidth;
            const handleWidth = handle.offsetWidth;
            const handleLeft = parseFloat(getComputedStyle(handle).left);
            const handleCenter = handleLeft + handleWidth / 2;
            let index = Math.round((handleCenter / progressBarWidth) * (switchCount - 1));
            const nearestPointPercentage = (index / (switchCount - 1)) * 100;
            handleStyle.left = nearestPointPercentage + '%';
            const progressWidthPercentage = (nearestPointPercentage / 100) * 100;
            progressBar.style.setProperty('--progress-width', progressWidthPercentage + '%');
            handle.left = nearestPointPercentage + '%';
            handle.style.setProperty('--progress-width', progressWidthPercentage + '%');
            timelineSwiper.slideTo(index);
            $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
            $(".swiper-pagination-custom .swiper-pagination-switch").eq(index).addClass("active");
    
            document.removeEventListener('mousemove', drag);
            document.removeEventListener('touchmove', drag);
            document.removeEventListener('mouseup', stopDragging);
            document.removeEventListener('touchend', stopDragging);
          }
        }
      }
    }
    

    handleDrag(progressBar);

    $(".swiper-pagination-custom .swiper-pagination-switch").click(function () {
      timelineSwiper.slideTo($(this).index());
      $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
      $(this).addClass("active");
      updateProgressBarWidth();
    });

    const switchCount = $('.swiper-pagination-switch').length;

    timelineSwiper.on('slideChange', function () {
      const activeIndex = timelineSwiper.realIndex;
      const nearestPointPercentage = (activeIndex / (switchCount - 1)) * 100;
      handle.style.left = nearestPointPercentage + '%';
    });
  }

 
}

export default timelineCarousel;